import { Empty, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

interface EmptyStateProps {
  icon?: string
  title?: string
  description?: string
  action?: React.ReactNode
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  const { t } = useTranslation()
  const displayTitle = title ?? t('noData')

  return (
    <div className="py-16">
      <Empty
        image={icon ? <span className="text-5xl">{icon}</span> : Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <>
            <Typography.Text strong>{displayTitle}</Typography.Text>
            {description && <Typography.Paragraph type="secondary" className="mt-1 mb-0">{description}</Typography.Paragraph>}
          </>
        }
      >
        {action}
      </Empty>
    </div>
  )
}
